<template>
    <div class="typing-indicator">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TypingIndicator'
  };
  </script>
  
  <style scoped>
  .typing-indicator {
    display: flex;
    align-items: center;
  }
  
  .dot {
    height: 10px;
    width: 10px;
    margin: 0 2px;
    background-color: #095636;
    border-radius: 50%;
    display: inline-block;
    animation: blink 1.4s infinite both;
  }
  
  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes blink {
    0%,
    80%,
    100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
  </style>
  